import React from "react";
import styled from "styled-components";
import { CallToAction, ExternalCallToAction } from "../call-to-action";
import { Content } from "../content";
import { Grid } from "../grid";
import { Spacer } from "../spacer";
import CoursesImage from "../../images/cta/background/courses.jpg";
import MRImage from "../../images/cta/background/mission-rabies.jpg";
import MRLogoImage from "../../images/cta/foreground/mission-rabies-logo.svg";
import WVSLogoImage from "../../images/wvs-logo.svg";
import IPANLogoImage from "../../images/charities/ipan.jpg";
import MarchigLogoImage from "../../images/charities/marchig.jpg";
import DogsTrustLogoImage from "../../images/charities/dogs-trust.jpg";
import FBBLogoImage from "../../images/charities/fbb.jpg";
import WTGLogoImage from "../../images/charities/wtg.jpg";
import AWBILogoImage from "../../images/charities/awbi.png";

const Image = styled.img`
  width: 100%;
  height: auto;
  max-width: 150px;
`;

const ImageSmall = styled(Image)`
  max-width: 100px;
`;

const CharityWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
`;

const ThankYouText = styled.p`
  font-weight: bold;
  text-align: center;
`;

export const ContentLinks = () => {
  return (
    <Content>
      <Grid columns={2}>
        <CallToAction image={CoursesImage} title="Programmes" to="/courses">
          Programmes
        </CallToAction>
        <ExternalCallToAction
          image={MRImage}
          href="http://www.missionrabies.com/"
          title="Mission Rabies"
        >
          <Image alt="Mission Rabies" src={MRLogoImage} />
          <p>
            WVS India is promoting rabies-control programs along with Mission
            Rabies
          </p>
        </ExternalCallToAction>
      </Grid>
      <Spacer height={3} />
      <ThankYouText>
        Thank you for the donors that make this work possible
      </ThankYouText>
      <Grid columns={3}>
        <CharityWrapper>
          <ImageSmall alt="WVS" src={WVSLogoImage} />
        </CharityWrapper>
        <CharityWrapper>
          <ImageSmall alt="FBB" src={FBBLogoImage} />
        </CharityWrapper>
        <CharityWrapper>
          <ImageSmall alt="WTG" src={WTGLogoImage} />
        </CharityWrapper>
      </Grid>
    </Content>
  );
};
